import { useLang } from "@/i18n";
import LegalDoc from "./LegalDoc";

export default function Privacy() {
  const { t } = useLang();
  return <LegalDoc doc={t.privacy} prefix="privacy" />;
}
